export const DatePickerType = {
  DATE: 'date', // 날짜 선택 타입.
  DATETIME: 'datetime', // 날짜 및 시간 선택 타입.
  MONTH: 'month', // 월 선택 타입.
  WEEK: 'week', // 주 선택 타입.
  CALENDAR: 'calendar',
} as const

export const ViewMode = {
  DATE: 'date',
  WEEK: 'week',
  MONTH: 'month',
  YEAR: 'year',
} as const

// TypeScript 타입 정의
export type DatePickerTypeValue = (typeof DatePickerType)[keyof typeof DatePickerType]
export type ViewModeValue = (typeof ViewMode)[keyof typeof ViewMode]
